// Reference – filtr realizací (tlačítka s aria-pressed, výsledek hlásí živá oblast)
(() => {
    const filter = document.querySelector(".JS-ref-filter");
    if (!filter) return;

    const items = document.querySelectorAll(".JS-ref-list > li");
    const status = document.querySelector(".JS-ref-status");
    const empty = document.querySelector(".JS-ref-empty");
    const buttons = filter.querySelectorAll("button");

    const label = (n) => {
        if (n === 1) return "Zobrazena 1 realizace";
        if (n >= 2 && n <= 4) return `Zobrazeny ${n} realizace`;
        return `Zobrazeno ${n} realizací`;
    };

    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            const tag = button.dataset.filter;
            let visible = 0;

            buttons.forEach((b) => b.setAttribute("aria-pressed", b === button ? "true" : "false"));
            items.forEach((item) => {
                const show = tag === "vse" || item.dataset.tags.split(" ").includes(tag);
                item.hidden = !show;
                if (show) visible++;
            });

            if (status) status.textContent = label(visible);
            if (empty) empty.hidden = visible > 0;
        });
    });
})();
